/**
 * usePageHelp Hook
 *
 * Purpose: Auto-resolve help article for the current route
 * Created: March 24, 2026
 */

import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { HelpService } from '../services/HelpService';
import type { HelpApp } from '@xanectech/types';

export const usePageHelp = (app: HelpApp) => {
  const location = useLocation();
  const pathname = location.pathname;

  return useQuery({
    queryKey: ['help-page-context', app, pathname],
    queryFn: () => HelpService.getContextMapping(app, pathname),
    staleTime: 10 * 60 * 1000,
  });
};
